import { GridRow } from '@mui/x-data-grid';
import type { InvoiceOverview } from '@weft/api-definition';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { VyTable, type VyTableMinimalProps } from '../../../../components/new-design/table/vy-table/VyTable';
import { CUSTOMER_INVOICES_TABLE_COLUMNS } from '../customer-invoices-page-consts/customer-invoices-columns';

export const CustomerInvoicesTable: React.FC<VyTableMinimalProps<InvoiceOverview>> = (props) => {
  return (
    <VyTable
      columns={CUSTOMER_INVOICES_TABLE_COLUMNS}
      sx={{
        paddingBottom: '90px',
      }}
      disableRowSelectionOnClick
      disableColumnMenu
      paginationClassName="bottom-[40px] right-[50px]"
      {...props} 
      slots={{
        row: (rowProps) => {
          const { id, customer } = rowProps.row;

          return (
            <NavLink
              onClick={(event: React.MouseEvent<HTMLAnchorElement> & { ignore?: boolean }) => {
                if (event.ignore) {
                  event.preventDefault();
                }
              }}
              to={`/customers/${customer.id}/invoices/${id}`}
            >
              <GridRow {...rowProps} />
            </NavLink>
          );
        },
      }}
    />
  );
};